import { render } from "./pdfvuer.vue?vue&type=template&id=0fb5a7a4"
import script from "./pdfvuer.vue?vue&type=script&lang=js"
export * from "./pdfvuer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__